function cuzLoader() {
	let loader = {};

	loader.body = $('body');

	loader.identifier = Math.floor(Math.random() * (99999 - 1)) + 1;

	loader.show = function () {
		loader.body.css({ 'overflow-y': 'hidden'});
		loader.element.addClass('is--active');
	}
	
	loader.hide = function () {
		loader.element.removeClass('is--active');
		loader.body.css({ 'overflow-y': 'auto'});
	}

	loader.html = `
		<div id="cuzloader-${loader.identifier}" class="cuzloader">
			<div class="cuzloader__wrapper">
				<div class="cuzloader__loading sk-fading-circle">
					<div class="sk-circle1 sk-circle"></div>
					<div class="sk-circle2 sk-circle"></div>
					<div class="sk-circle3 sk-circle"></div>
					<div class="sk-circle4 sk-circle"></div>
					<div class="sk-circle5 sk-circle"></div>
					<div class="sk-circle6 sk-circle"></div>
					<div class="sk-circle7 sk-circle"></div>
					<div class="sk-circle8 sk-circle"></div>
					<div class="sk-circle9 sk-circle"></div>
					<div class="sk-circle10 sk-circle"></div>
					<div class="sk-circle11 sk-circle"></div>
					<div class="sk-circle12 sk-circle"></div>
				</div>
				<p class="cuzloader__text">Cargando...</p>
			</div>
		</div>
	`;

	loader.body.append(loader.html);

	loader.element = $(`#cuzloader-${loader.identifier}`);

	return loader;
}